const setUsers = (state, users) => state.users = users;

const setVetsWithoutPagination = (state, vets_without_pagination) => {
  state.vets_without_pagination = vets_without_pagination
};

const setOwnersWithoutPagination = (state, owners_without_pagination) => {
  state.owners_without_pagination = owners_without_pagination
};

let mutations = {
  setUsers,
  setVetsWithoutPagination,
  setOwnersWithoutPagination
};

export default mutations;
